var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appConfig from '../helpers/appConfig';
import { nvFetch } from '../helpers/nvFetch';
import { finaliseLogout } from './user';
const combineArrays = (oldArr, newArr) => {
    return newArr.map((newItem) => {
        const oldItem = oldArr.find((o) => o.id === newItem.id);
        return !oldItem
            ? newItem
            : Object.assign(Object.assign({}, newItem), { status: oldItem.status, subscribed: oldItem.subscribed, subscription: oldItem.subscription });
    });
};
const initialState = {
    isFetching: false,
    error: undefined,
    phonebook: [],
    phones: [],
    virtuals: [],
    visibilityFilter: 'SHOW_ENDPOINTS',
    searchString: '',
};
export const fetchContacts = createAsyncThunk('contacts/fetch', (_, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const customerId = (_a = thunkAPI.getState().client.activeCustomer) === null || _a === void 0 ? void 0 : _a.id;
    const getPhonebook = () => __awaiter(void 0, void 0, void 0, function* () {
        const fetchRes = yield nvFetch(`/customers/${customerId}/phonebook?pageSize=200`);
        return (yield fetchRes.json()).items;
    });
    const getPhoneExtensions = () => __awaiter(void 0, void 0, void 0, function* () {
        const fetchRes = yield nvFetch(`/customers/${customerId}/endpoints?type=phone&extended=true&pageSize=200`);
        const phoneExtensions = (yield fetchRes.json())
            .items;
        return phoneExtensions.map((e) => (Object.assign(Object.assign({}, e), { username: String(`00000${e.id}`).slice(-6) })));
    });
    const getVirtualExtensions = () => __awaiter(void 0, void 0, void 0, function* () {
        const fetchRes = yield nvFetch(`/customers/${customerId}/endpoints?type=virtual&pageSize=200`);
        return (yield fetchRes.json()).items;
    });
    const [phonebook, virtuals, phones] = yield Promise.all([
        getPhonebook(),
        getVirtualExtensions(),
        getPhoneExtensions(),
    ]);
    if (appConfig.extension) {
        // FIXME ????
        // subscribePhones();
    }
    return { phonebook, virtuals, phones };
}));
const subscribePhone = (phone, domain) => {
    var _a;
    (_a = appConfig.extension) === null || _a === void 0 ? void 0 : _a.subscribe(phone.username, domain);
};
export const subscribePhones = createAsyncThunk('contacts/subscribePhones', (_, thunkAPI) => {
    var _a;
    const { contacts: { phones }, extension, } = thunkAPI.getState();
    if ((_a = extension.extension) === null || _a === void 0 ? void 0 : _a.sip) {
        const { domain } = extension.extension.sip;
        phones
            .filter((phone) => !phone.subscribed)
            .forEach((phone) => {
            subscribePhone(phone, domain);
        });
    }
    else {
        /**
         * If we've not got the extension's sip credentials yet
         * then wait for a second and try again
         */
        setTimeout(() => {
            thunkAPI.dispatch(subscribePhones());
        }, 1000);
    }
});
const contactsSlice = createSlice({
    name: 'contacts',
    initialState,
    reducers: {
        visibilityFilterSet: (state, action) => {
            state.visibilityFilter = action.payload.filter;
        },
        // FIXME those names...
        contactsSearched: (state, action) => {
            state.searchString = action.payload.searchString;
        },
        phoneStatusSet: (state, action) => {
            const { id, status } = action.payload;
            state.phones = [...state.phones].map((p) => p.username === id ? Object.assign(Object.assign({}, p), { status, subscribed: true }) : p);
        },
        phonesUnsubscribed: (state) => {
            state.phones = [...state.phones].map((p) => (Object.assign(Object.assign({}, p), { subscribed: false })));
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContacts.pending, (state) => {
            state.isFetching = true;
        })
            .addCase(fetchContacts.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.error;
        })
            .addCase(fetchContacts.fulfilled, (state, action) => {
            const { phonebook = [], phones = [], virtuals = [] } = action.payload;
            const { phonebook: prevPhonebook, phones: prevPhones, virtuals: prevVirtuals, } = state;
            const combinedPhonebook = combineArrays(prevPhonebook, phonebook);
            const combinedPhones = combineArrays(prevPhones, phones);
            const combinedVirtuals = combineArrays(prevVirtuals, virtuals);
            state.phonebook = combinedPhonebook;
            state.phones = combinedPhones;
            state.virtuals = combinedVirtuals;
            state.isFetching = false;
            state.error = undefined;
        })
            .addCase(finaliseLogout.fulfilled, () => initialState);
    },
});
export const { contactsSearched, visibilityFilterSet, phoneStatusSet, phonesUnsubscribed, } = contactsSlice.actions;
export default contactsSlice.reducer;
